<template>
  <div>
    <pdf-preview
      v-show="inPreview"
      :inPreview="inPreview"
      :generatingPreview="generatingPreview"
      :saving="saving"
      :pdfUrl="pdfUrl"
      :backToForm="backToForm"
      :save="save"
    />
    <div v-show="!inPreview">
      <form class="mb-5" autocomplete="off" @submit.prevent>
        <h2>
          FORMULARIO SOLICITUD CONVENIO HONORARIOS
          {{ isDocenteForm ? ' (DOCENTE)' : '' }}
          {{ isNotDocenteForm ? ' (NO DOCENTE)' : '' }}
        </h2>
        <div class="row">
          <div class="col-12">
            <b-form-group>
              <label for="formType">
                ¿Deseas basarte en otro documento?
              </label>
              <v-select
                v-model="previousDocument"
                :options="createdDocuments"
                name="previousDocument"
                label="label"
                data-cy="created-document-data"
                @input="getDocumentData($event)"
                :clearable="true"
              >
                <template slot="no-options">
                  no hay documentos registrados
                </template>
                <template #list-footer v-if="hasMoreDocuments">
                  <li class="text-center py-2" style="border-top: 1px solid #e8e8e8;">
                    <a
                      href="#"
                      @click.prevent="loadMoreDocuments"
                      style="color: #7367f0; font-weight: 500;"
                    >
                      {{ loadingMoreDocuments ? 'Cargando...' : 'Cargar más documentos' }}
                    </a>
                  </li>
                </template>
              </v-select>
              <v-invalid-feedback v-if="$validator.errors.has('formType')">
                {{ $validator.errors.first('formType') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12" v-if="!formData.formType">
            <b-form-group>
              <label for="formType">
                Tipo de formulario
                <span v-html="required('formType')"/>
              </label>
              <v-select
                :class="{ 'v-select-danger': $validator.errors.has('formType') }"
                data-cy='formType'
                name='formType'
                data-vv-as='tipo de formulario'
                placeholder="Por favor, selecciona un tipo de formulario"
                v-model="formData.formType"
                :state="$validator.errors.has('formType') ? false : null"
                :danger="$validator.errors.has('formType')"
                :danger-text="$validator.errors.first('formType')"
                v-validate="'required'"
                :selectable="opt => !opt.disabled"
                :options="formTypeOptions"
                :clearable="true"
              />
              <v-invalid-feedback v-if="$validator.errors.has('formType')">
                {{ $validator.errors.first('formType') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
        </div>
        <div class="row" v-if="formData.formType">
          <div class="col-12">
            <vs-button
              class="w-100 mt-4"
              size="small"
              color="primary"
              type="border"
              icon="refresh"
              @click="changeFormType()"
            >
              Cambiar tipo de formulario
            </vs-button>
          </div>
          <div class="col-12 my-2">
            <vs-divider/>
          </div>
          <div class="col-12 mb-5">
            <h4>DATOS DE LA PERSONA QUE SE SOLICITA SEA CONTRATADA A HONORARIOS</h4>
          </div>
          <div class="col-12 mb-2">
            <h5>PERSONALES</h5>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="fullName">
                Nombre completo
                <span v-html="required('fullName')"/>
              </label>
              <b-form-input
                data-cy='fullName'
                name='fullName'
                data-vv-as='nombre completo'
                placeholder='Nombre completo...'
                v-model="formData.fullName"
                :state="$validator.errors.has('fullName') ? false : null"
                :danger="$validator.errors.has('fullName')"
                :danger-text="$validator.errors.first('fullName')"
                v-validate="'required'"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('fullName')">
                {{ $validator.errors.first('fullName') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="rut">
                RUT
                <span v-html="required('rut')"/>
              </label>
              <b-form-input-rut
                data-cy='rut'
                name='rut'
                data-vv-as='rut'
                placeholder='Ej: 12345678-9'
                v-model="formData.rut"
                :state="$validator.errors.has('rut') ? false : null"
                :danger="$validator.errors.has('rut')"
                :danger-text="$validator.errors.first('rut')"
                v-validate="'required|validateRut'"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('rut')">
                {{ $validator.errors.first('rut') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="birthDate">
                Fecha de nacimiento
                <span v-html="required('birthDate')"/>
              </label>
              <date-picker
                :class="{
                'w-100': true,
                'danger': $validator.errors.has('birthDate'),
              }"
                data-cy='birthDate'
                name='birthDate'
                data-vv-as='fecha de nacimiento'
                v-model="formData.birthDate"
                format='DD/MM/YYYY'
                value-type='DD/MM/YYYY'
                placeholder='Ej: 30/12/2000'
                v-validate="'required'"
                :danger="$validator.errors.has('birthDate')"
              />
              <v-invalid-feedback v-if="$validator.errors.has('birthDate')">
                {{ $validator.errors.first('birthDate') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="address">
                Domicilio
                <span v-html="required('address')"/>
              </label>
              <b-form-input
                data-cy='address'
                name='address'
                data-vv-as='domicilio'
                placeholder='Domicilio...'
                v-model="formData.address"
                :state="$validator.errors.has('address') ? false : null"
                :danger="$validator.errors.has('address')"
                :danger-text="$validator.errors.first('address')"
                v-validate="'required'"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('address')">
                {{ $validator.errors.first('address') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="city">
                Ciudad
                <span v-html="required('city')"/>
              </label>
              <v-select-city
                :parent="$vnode"
                name="city"
                data-cy='city'
                data-vv-as='ciudad'
                v-model="formData.city"
                :state="$validator.errors.has('city') ? false : null"
                :danger="$validator.errors.has('city')"
                :danger-text="$validator.errors.first('city')"
                v-validate="'required'"
              />
              <v-invalid-feedback v-if="$validator.errors.has('city')">
                {{ $validator.errors.first('city') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="email">
                Correo electrónico
                <span v-html="required('email')"/>
              </label>
              <b-form-input
                type="email"
                data-cy='email'
                ref="email"
                name='email'
                data-vv-as='correo electrónico'
                placeholder='Correo electrónico...'
                v-model="formData.email"
                :state="$validator.errors.has('email') ? false : null"
                :danger="$validator.errors.has('email')"
                :danger-text="$validator.errors.first('email')"
                v-validate="'required|email'"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('email')">
                {{ $validator.errors.first('email') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="confirmEmail">
                Confirmación correo electrónico
                <span v-html="required('confirmEmail')" />
              </label>
              <b-form-input
                type="email"
                data-cy='confirmEmail'
                name='confirmEmail'
                data-vv-as='confirmación de correo electrónico'
                placeholder='Por favor ingrese de nuevo el correo electrónico...'
                v-model="formData.confirmEmail"
                :state="$validator.errors.has('confirmEmail') ? false : null"
                :danger="$validator.errors.has('confirmEmail')"
                :danger-text="$validator.errors.first('confirmEmail')"
                v-validate="'required|email|confirmed:email'"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('confirmEmail')">
                {{ $validator.errors.first('confirmEmail') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="nationality">
                Nacionalidad
                <span v-html="required('nationality')"/>
              </label>
              <v-select-nationality
                :parent="$vnode"
                name="nationality"
                data-cy='nationality'
                data-vv-as='nacionalidad'
                v-model="formData.nationality"
                :state="$validator.errors.has('nationality') ? false : null"
                :danger="$validator.errors.has('nationality')"
                :danger-text="$validator.errors.first('nationality')"
                v-validate="'required'"
              />
              <v-invalid-feedback v-if="$validator.errors.has('nationality')">
                {{ $validator.errors.first('nationality') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="isStudent">
                Estudiante
                <span v-html="required('isStudent')"/>
              </label>
              <v-select
                :class="{ 'v-select-danger': $validator.errors.has('isStudent') }"
                data-cy='isStudent'
                name='isStudent'
                data-vv-as='estudiante'
                placeholder="Por favor, selecciona una opción"
                v-model="formData.isStudent"
                :state="$validator.errors.has('isStudent') ? false : null"
                :danger="$validator.errors.has('isStudent')"
                :danger-text="$validator.errors.first('isStudent')"
                v-validate="'required'"
                :selectable="opt => !opt.disabled"
                :options="yesOrNoOptions"
              />
              <v-invalid-feedback v-if="$validator.errors.has('isStudent')">
                {{ $validator.errors.first('isStudent') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="phoneNumber">
                Número telefónico
                <span v-html="required('phoneNumber')"/>
              </label>
              <b-form-input
                type="tel"
                data-cy='phoneNumber'
                name='phoneNumber'
                data-vv-as='número telefónico'
                placeholder='Número telefónico...'
                v-model="formData.phoneNumber"
                :state="$validator.errors.has('phoneNumber') ? false : null"
                :danger="$validator.errors.has('phoneNumber')"
                :danger-text="$validator.errors.first('phoneNumber')"
                v-validate="'required'"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('phoneNumber')">
                {{ $validator.errors.first('phoneNumber') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="institutionalEmail">
                Correo institucional
                <span v-html="required('institutionalEmail')"/>
              </label>
              <b-form-input
                type="tel"
                data-cy='institutionalEmail'
                name='institutionalEmail'
                data-vv-as='Correo institucional'
                placeholder='Correo institucional...'
                v-model="formData.institutionalEmail"
                :state="$validator.errors.has('institutionalEmail') ? false : null"
                :danger="$validator.errors.has('institutionalEmail')"
                :danger-text="$validator.errors.first('institutionalEmail')"
                v-validate="'required|email'"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('institutionalEmail')">
                {{ $validator.errors.first('institutionalEmail') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 my-2">
            <vs-divider/>
          </div>
          <div class="col-12 mb-2">
            <h5>EDUCACIONALES</h5>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="title">
                Título profesional/técnico
                <span v-html="required('title')"/>
              </label>
              <v-select-title
                :parent="$vnode"
                name="title"
                data-cy='title'
                data-vv-as='título profesional/técnico'
                v-model="formData.title"
                :state="$validator.errors.has('title') ? false : null"
                :danger="$validator.errors.has('title')"
                :danger-text="$validator.errors.first('title')"
                v-validate="'required'"
              />
              <v-invalid-feedback v-if="$validator.errors.has('title')">
                {{ $validator.errors.first('title') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="university">
                Universidad u otra institución
                <span v-html="required('university')"/>
              </label>
              <v-select-university
                :parent="$vnode"
                name="university"
                data-cy='university'
                data-vv-as='universidad u otra institución'
                v-model="formData.university"
                :state="$validator.errors.has('university') ? false : null"
                :danger="$validator.errors.has('university')"
                :danger-text="$validator.errors.first('university')"
                v-validate="'required'"
              />
              <v-invalid-feedback v-if="$validator.errors.has('university')">
                {{ $validator.errors.first('university') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="academicDegree">
                Grado Académico
                <span v-html="required('academicDegree')"/>
              </label>
              <v-select-academic-degree
                :parent="$vnode"
                name="academicDegree"
                data-cy='academicDegree'
                data-vv-as='grado académico'
                v-model="formData.academicDegree"
                :state="$validator.errors.has('academicDegree') ? false : null"
                :danger="$validator.errors.has('academicDegree')"
                :danger-text="$validator.errors.first('academicDegree')"
                v-validate="'required'"
              />
              <v-invalid-feedback v-if="$validator.errors.has('academicDegree')">
                {{ $validator.errors.first('academicDegree') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 my-2">
            <vs-divider/>
          </div>
          <div class="col-12 mb-2" v-if="isNotDocenteForm">
            <h5>EXPERIENCIA Y/O EXPERTICIA</h5>
          </div>
          <div class="col-12" v-if="isNotDocenteForm">
            <b-form-group>
              <label for="experience">
                Experiencia
                <span v-html="required('experience')"/>
              </label>
              <b-form-textarea
                rows="3"
                data-cy='experience'
                name='experience'
                data-vv-as='experiencia'
                placeholder='Experiencia...'
                v-model="formData.experience"
                :state="$validator.errors.has('experience') ? false : null"
                :danger="$validator.errors.has('experience')"
                :danger-text="$validator.errors.first('experience')"
                @input="validateAttachments"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('experience')">
                {{ $validator.errors.first('experience') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 text-xs text-primary" v-if="formData.experience">
            Debe adjuntar un documento que acredite la <b>experiencia</b>
          </div>
          <div class="col-12" v-if="isNotDocenteForm">
            <file-list
              :files="experienceFiles"
              @remove-file="removeExperienceFile"
            />
          </div>
          <div class="col-6" v-if="formData.experience && !experienceFiles.length">
            <b-button
              variant="primary"
              class="btn-icon mt-1 w-100"
              data-cy="from-repository"
              v-has-permission="'ED060'"
              v-b-modal="'add-repository-experience-file'"
              :disabled="experienceFiles.length >= maxExperienceFiles"
            >
              <feather-icon icon="ServerIcon"/>
              Seleccionar desde repositorio
            </b-button>
          </div>
          <div class="col-6" v-if="formData.experience && !experienceFiles.length">
            <upload-file
              color="primary"
              permission="*"
              accept="application/pdf, .doc, .docx, .xlsv, .ppt"
              text="Seleccionar desde su dispositivo"
              v-model="experienceFile"
              data-cy="uploadFile"
              upload-to="ed"
              button-class="btn-block"
              container-class="w-100"
              @input="addExperienceFile"
            />
          </div>
          <div class="col-12" v-if="experienceFileError">
            <v-invalid-feedback>
              {{ experienceFileError }}
            </v-invalid-feedback>
          </div>
          <div class="col-12 mt-4" v-if="isNotDocenteForm">
            <b-form-group>
              <label for="expertise">
                Experticia
                <span v-html="required('expertise')"/>
              </label>
              <b-form-textarea
                rows="3"
                data-cy='expertise'
                name='expertise'
                data-vv-as='experticia'
                placeholder='Experticia...'
                @input="validateAttachments"
                v-model="formData.expertise"
                :state="$validator.errors.has('expertise') ? false : null"
                :danger="$validator.errors.has('expertise')"
                :danger-text="$validator.errors.first('expertise')"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('expertise')">
                {{ $validator.errors.first('expertise') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 text-xs text-primary" v-if="formData.experience">
            Debe adjuntar un documento que acredite la <b>experticia</b>
          </div>
          <div class="col-12">
            <file-list
              :files="expertiseFiles"
              @remove-file="removeExpertiseFile"
            />
          </div>
          <div class="col-6" v-if="formData.expertise && !expertiseFiles.length">
            <b-button
              variant="primary"
              class="btn-icon mt-1 w-100"
              data-cy="from-repository"
              v-has-permission="'ED060'"
              v-b-modal="'add-repository-expertise-file'"
              :disabled="expertiseFiles.length >= maxExpertiseFiles"
            >
              <feather-icon icon="ServerIcon"/>
              Seleccionar desde repositorio
            </b-button>
          </div>
          <div class="col-6" v-if="formData.expertise && !expertiseFiles.length">
            <upload-file
              color="primary"
              permission="*"
              accept="application/pdf, .doc, .docx, .xlsv, .ppt"
              text="Seleccionar desde su dispositivo"
              v-model="expertiseFile"
              data-cy="uploadFile"
              upload-to="ed"
              button-class="btn-block"
              container-class="w-100"
              @input="addExpertiseFile"
            />
          </div>
          <div class="col-12" v-if="expertiseFileError">
            <v-invalid-feedback>
              {{ expertiseFileError }}
            </v-invalid-feedback>
          </div>
          <div class="col-12" v-if="isNotDocenteForm">
            <vs-divider/>
          </div>
          <div class="col-12 mb-2">
            <h5>PREVISIÓN Y SALUD</h5>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="healthInsurance">
                Seguro de salud (ISAPRE/FONASA)
                <span v-html="required('healthInsurance')"/>
              </label>
              <v-select-isapres
                :parent="$vnode"
                name="healthInsurance"
                data-cy='healthInsurance'
                data-vv-as='seguro de salud'
                v-model="formData.healthInsurance"
                :state="$validator.errors.has('healthInsurance') ? false : null"
                :danger="$validator.errors.has('healthInsurance')"
                :danger-text="$validator.errors.first('healthInsurance')"
                v-validate="'required'"
                include-fonasa
              />
              <v-invalid-feedback v-if="$validator.errors.has('healthInsurance')">
                {{ $validator.errors.first('healthInsurance') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="afp">
                AFP
                <span v-html="required('afp')"/>
              </label>
              <v-select-afps
                :parent="$vnode"
                name="afp"
                data-cy='afp'
                data-vv-as='afp'
                v-model="formData.afp"
                :state="$validator.errors.has('afp') ? false : null"
                :danger="$validator.errors.has('afp')"
                :danger-text="$validator.errors.first('afp')"
                v-validate="'required'"
              />
              <v-invalid-feedback v-if="$validator.errors.has('afp')">
                {{ $validator.errors.first('afp') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 my-2">
            <vs-divider/>
          </div>
          <div class="col-12 mb-2" v-if="isDocenteForm">
            <h5>HORAS DE TRABAJO Y REMUNERACIÓN</h5>
          </div>
          <div class="col-12" v-if="isNotDocenteForm">
            <vs-table
              hoverFlat
              class="wrap-table shadow"
              :data="formData.associatedProduct || []"
              noDataText="No hay actividades aún"
            >
              <template slot-scope="{data}">
                <thead>
                <th class="text-center">
                  Productos y servicios asociados
                </th>
                </thead>
                <tbody>
                <vs-tr :key="idx" v-for="(_, idx) in data">
                  <vs-td class="table-part" :data="data[idx]">
                    <b-row :ref="`associatedProduct[${idx}].row`" class="border mx-1 my-2 py-4">
                      <b-col cols="6">
                        <b-form-group>
                          <label :for="`associatedProduct[${idx}].product`">
                            Servicio/Producto
                            <span
                              v-html="required(`associatedProduct[${idx}].product`)"
                            />
                          </label>
                          <b-form-textarea
                            rows="2"
                            :name="`associatedProduct[${idx}].product`"
                            :data-cy="`associatedProduct[${idx}].product`"
                            data-vv-as="servicio/producto"
                            placeholder="Servicio/Producto..."
                            v-model="data[idx].product"
                            :state="$validator.errors.has(`associatedProduct[${idx}].product`)? false : null"
                            :danger="$validator.errors.has(`associatedProduct[${idx}].product`)"
                            :danger-text="$validator.errors.first(`associatedProduct[${idx}].product`)"
                            v-validate="'required'"
                          />
                          <b-form-invalid-feedback
                            v-if="$validator.errors.has(`associatedProduct[${idx}].product`)"
                          >
                            {{$validator.errors.first(`associatedProduct[${idx}].product`) }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group>
                          <label :for="`associatedProduct[${idx}].subproduct`">
                            Medio de verificación o subproducto
                            <span v-html="required(`associatedProduct[${idx}].subproduct`)"/>
                          </label>
                          <b-form-textarea
                            rows="2"
                            :name="`associatedProduct[${idx}].subproduct`"
                            :data-cy='`associatedProduct[${idx}].subproduct`'
                            data-vv-as='medio de verificación o subproducto'
                            placeholder='Medio de verificación o subproducto...'
                            v-model="data[idx].subproduct"
                            :state="$validator.errors.has(`associatedProduct[${idx}].subproduct`)? false : null"
                            :danger="$validator.errors.has(`associatedProduct[${idx}].subproduct`)"
                            :danger-text="$validator.errors.first(`associatedProduct[${idx}].subproduct`)"
                            v-validate="'required'"
                          />
                          <b-form-invalid-feedback
                            v-if="$validator.errors.has(`associatedProduct[${idx}].subproduct`)"
                          >
                            {{$validator.errors.first(`associatedProduct[${idx}].subproduct`) }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group>
                          <label :for="`associatedProduct[${idx}].period`">
                            Periodo
                            <span
                              v-html="required(`associatedProduct[${idx}].period`)"
                            />
                          </label>
                          <v-select-period
                            :parent="$vnode"
                            :name="`associatedProduct[${idx}].period`"
                            :data-cy='`associatedProduct[${idx}].period`'
                            data-vv-as='periodo'
                            v-model="data[idx].period"
                            :state="$validator.errors.has(`associatedProduct[${idx}].period`)? false : null"
                            :danger="$validator.errors.has(`associatedProduct[${idx}].period`)"
                            :danger-text="$validator.errors.first(`associatedProduct[${idx}].period`)"
                            v-validate="'required'"
                          />
                          <v-invalid-feedback
                            v-if="$validator.errors.has(`associatedProduct[${idx}].period`)"
                          >
                            {{$validator.errors.first(`associatedProduct[${idx}].period`) }}
                          </v-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group>
                          <label :for="`associatedProduct[${idx}].bruteValuation`">
                            Valorización bruta
                            <span v-html="required(`associatedProduct[${idx}].bruteValuation`)" />
                          </label>
                          <input-currency
                            class="mb-0"
                            label=""
                            :options="currencyInputOptions"
                            :name="`associatedProduct[${idx}].bruteValuation`"
                            :data-cy='`associatedProduct[${idx}].bruteValuation`'
                            data-vv-as='valorización bruta'
                            placeholder='Valorización bruta...'
                            v-model="data[idx].bruteValuation"
                            :state="$validator.errors.has(`associatedProduct[${idx}].bruteValuation`)? false : null"
                            :danger="$validator.errors.has(`associatedProduct[${idx}].bruteValuation`)"
                            :danger-text="$validator.errors.first(`associatedProduct[${idx}].bruteValuation`)"
                            v-validate="'required'"
                          />
                          <b-form-invalid-feedback
                            v-if="$validator.errors.has(`associatedProduct[${idx}].bruteValuation`)"
                          >
                            {{$validator.errors.first(`associatedProduct[${idx}].bruteValuation`)}}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12 d-flex justify-content-end">
                        <vs-button
                          color="danger"
                          type="border"
                          icon="delete"
                          @click="removeAssociatedProductRow(idx)"
                        >
                          Eliminar fila
                        </vs-button>
                      </b-col>
                    </b-row>
                  </vs-td>
                </vs-tr>
                </tbody>
                <tfoot>
                <vs-tr>
                  <vs-td colspan="3">
                    <vs-button
                      class="w-100"
                      color="primary"
                      type="border"
                      icon="add"
                      @click="addAssociatedProductRow"
                    >
                      Agregar fila
                    </vs-button>
                  </vs-td>
                </vs-tr>
                </tfoot>
              </template>
            </vs-table>
          </div>
          <div class="col-12" v-if="isDocenteForm">
            <vs-table
              hoverFlat
              class="wrap-table shadow"
              :data="formData.workHoursAndRemuneration || []"
              noDataText="No hay actividades aún"
            >
              <template slot-scope="{data}">
                <thead>
                <th class="text-center">Horas de trabajo y remuneración</th>
                </thead>
                <tbody>
                <vs-tr :key="idx" v-for="(_, idx) in data">
                  <vs-td class="table-part" :data="data[idx]">
                    <b-row :ref="`workHoursAndRemuneration[${idx}].row`" class="border mx-1 my-2 py-4">
                      <b-col cols="6">
                        <b-form-group>
                          <label :for="`workHoursAndRemuneration[${idx}].subject`">
                            Asignatura
                            <span
                              v-html="required(`workHoursAndRemuneration[${idx}].subject`)"
                            />
                          </label>
                          <v-select-subject
                            :parent="$vnode"
                            :name="`workHoursAndRemuneration[${idx}].subject`"
                            :data-cy="`workHoursAndRemuneration[${idx}].subject`"
                            data-vv-as='asignatura'
                            v-model="data[idx].subject"
                            :danger="$validator.errors.has(`workHoursAndRemuneration[${idx}].subject`)"
                            v-validate="'required'"
                            label-with-code
                            @full-input="(e) => setSubject(e, idx)"
                          />
                          <v-invalid-feedback
                            v-if="$validator.errors.has(`workHoursAndRemuneration[${idx}].subject`)"
                          >
                            {{$validator.errors.first(`workHoursAndRemuneration[${idx}].subject`)}}
                          </v-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group>
                          <label :for="`workHoursAndRemuneration[${idx}].subject`">
                            Carrera
                            <span
                              v-html="required(`workHoursAndRemuneration[${idx}].subject`)"
                            />
                          </label>
                          <v-select-career
                            :parent="$vnode"
                            :name="`workHoursAndRemuneration[${idx}].subjectCareer`"
                            :data-cy="`workHoursAndRemuneration[${idx}].subjectCareer`"
                            data-vv-as='carrera'
                            v-model="data[idx].subjectCareer"
                            :danger="$validator.errors.has(`workHoursAndRemuneration[${idx}].subjectCareer`)"
                            v-validate="'required'"
                            label-with-code
                          />
                          <v-invalid-feedback
                            v-if="$validator.errors.has(`workHoursAndRemuneration[${idx}].subjectCareer`)"
                          >
                            {{$validator.errors.first(`workHoursAndRemuneration[${idx}].subjectCareer`)}}
                          </v-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group>
                          <label :for="`workHoursAndRemuneration[${idx}].headOfCareer`">
                            Jefe De Carrera
                            <span v-html="required(`workHoursAndRemuneration[${idx}].headOfCareer`)" />
                          </label>
                          <v-select-head-of-career
                            :parent="$vnode"
                            :name="`workHoursAndRemuneration[${idx}].headOfCareer`"
                            :data-cy="`workHoursAndRemuneration[${idx}].headOfCareer`"
                            data-vv-as='jefe de carrera'
                            v-model="data[idx].headOfCareer"
                            :danger="$validator.errors.has(`workHoursAndRemuneration[${idx}].headOfCareer`)"
                            v-validate="'required'"
                            label-with-code
                          />
                          <v-invalid-feedback
                            v-if="$validator.errors.has(`workHoursAndRemuneration[${idx}].headOfCareer`)"
                          >
                            {{$validator.errors.first(`workHoursAndRemuneration[${idx}].headOfCareer`)}}
                          </v-invalid-feedback>
                        </b-form-group>
                        <b-form-group>
                          <label :for="`workHoursAndRemuneration[${idx}].docentHours`">
                            N° horas docentes
                            <span v-html="required(`workHoursAndRemuneration[${idx}].docentHours`)" />
                          </label>
                          <b-form-input
                            type="number"
                            :data-cy="`workHoursAndRemuneration[${idx}].docentHours`"
                            :name="`workHoursAndRemuneration[${idx}].docentHours`"
                            :data-vv-as="'n° horas docentes'"
                            placeholder='N° horas docentes...'
                            v-model="data[idx].docentHours"
                            :state="$validator.errors.has(`workHoursAndRemuneration[${idx}].docentHours`)? false : null"
                            :danger="$validator.errors.has(`workHoursAndRemuneration[${idx}].docentHours`)"
                            :danger-text="$validator.errors.first(`workHoursAndRemuneration[${idx}].docentHours`)"
                            min="0"
                            v-validate="{ required: isDocentHoursRequired(idx), min_value: docentHoursMinValue(idx) }"
                          />
                          <b-form-invalid-feedback
                            v-if="$validator.errors.has(`workHoursAndRemuneration[${idx}].docentHours`)"
                          >
                            {{$validator.errors.first(`workHoursAndRemuneration[${idx}].docentHours`)}}
                          </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group>
                          <label :for="`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountA`">
                            Monto hora docente colaborador (horas docentes)
                            <span
                              v-html="required(`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountA`)"
                            />
                          </label>
                          <input-currency
                            class="mb-0"
                            label=""
                            placeholder='Ingresa un monto...'
                            :options="currencyInputOptions"
                            :data-cy=" `workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountA`"
                            v-model="data[idx].collaboratorDocentHourAmountA"
                            data-vv-as="monto hora docente colaborador (horas docentes)"
                            :id="`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountA`"
                            :name="`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountA`"
                            :state="$validator.errors.has(`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountA`) ? false : null"
                            :danger="$validator.errors.has(`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountA`)"
                            :danger-text="$validator.errors.first( `workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountA`)"
                            v-validate="{ required: isCollaboratorDocentHourAmountARequired(idx), min_value: colaboratorDocentHourAmountAMinValue(idx) }"
                          />
                          <b-form-invalid-feedback
                            v-if="$validator.errors.has(`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountA`)"
                          >
                            {{$validator.errors.first(`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountA`)}}
                          </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group>
                          <label :for="`workHoursAndRemuneration[${idx}].factorA`">
                            Factor (horas docentes)
                            <span
                              v-html="required(`workHoursAndRemuneration[${idx}].factorA`)"
                            />
                          </label>
                          <b-form-input
                            type="number"
                            :data-cy="`workHoursAndRemuneration[${idx}].factorA`"
                            :name="`workHoursAndRemuneration[${idx}].factorA`"
                            :data-vv-as="'factor'"
                            placeholder='Factor...'
                            v-model="data[idx].factorA"
                            :state="$validator.errors.has(`workHoursAndRemuneration[${idx}].factorA`)? false : null"
                            :danger="$validator.errors.has(`workHoursAndRemuneration[${idx}].factorA`)"
                            :danger-text="$validator.errors.first(`workHoursAndRemuneration[${idx}].factorA`)"
                            v-validate="{
                            required: isFactorARequired(idx),
                            min_value: factorAMinValue(idx),
                          }"
                          />
                          <b-form-invalid-feedback
                            v-if="$validator.errors.has(`workHoursAndRemuneration[${idx}].factorA`)"
                          >
                            {{$validator.errors.first(`workHoursAndRemuneration[${idx}].factorA`)}}
                          </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group>
                          <label :for="`workHoursAndRemuneration[${idx}].subtotalA`">
                            Subtotal (horas docentes)
                          </label>
                          <b-form-input
                            disabled
                            :data-cy="`workHoursAndRemuneration[${idx}].subtotalA`"
                            :name="`workHoursAndRemuneration[${idx}].subtotalA`"
                            :data-vv-as="'subtotal'"
                            placeholder='Producto datos anteriores...'
                            v-model="data[idx].subtotalA"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group>
                          <label
                            :for="`workHoursAndRemuneration[${idx}].otherActivitiesHours`"
                          >
                            N° horas otras actividades
                            <span
                              v-html="required(`workHoursAndRemuneration[${idx}].otherActivitiesHours`)"
                            />
                          </label>
                          <b-form-input
                            type="number"
                            :data-cy="`workHoursAndRemuneration[${idx}].otherActivitiesHours`"
                            :name="`workHoursAndRemuneration[${idx}].otherActivitiesHours`"
                            :data-vv-as="'n° horas otras actividades'"
                            placeholder='N° horas otras actividades...'
                            v-model="formData.workHoursAndRemuneration[idx].otherActivitiesHours"
                            :state="$validator.errors.has(`workHoursAndRemuneration[${idx}].otherActivitiesHours`) ? false : null"
                            :danger="$validator.errors.has(`workHoursAndRemuneration[${idx}].otherActivitiesHours`)"
                            :danger-text="$validator.errors.first(`workHoursAndRemuneration[${idx}].otherActivitiesHours`)"
                            v-validate="{required: isOtherActivitiesHoursRequired(idx), min_value: otherActivitiesHoursMinValue(idx)}"
                          />
                          <b-form-invalid-feedback
                            v-if="$validator.errors.has(`workHoursAndRemuneration[${idx}].otherActivitiesHours`)"
                          >
                            {{$validator.errors.first(`workHoursAndRemuneration[${idx}].otherActivitiesHours`)}}
                          </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group>
                          <label
                            :for="`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountB`"
                          >
                            Monto hora docente colaborador (otras actividades)
                            <span
                              v-html="required(`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountB`)"
                            />
                          </label>
                          <input-currency
                            class="mb-0"
                            label=""
                            placeholder='Ingresa un monto...'
                            :options="currencyInputOptions"
                            v-model="data[idx].collaboratorDocentHourAmountB"
                            :id="`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountB`"
                            :name="`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountB`"
                            :data-cy="`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountB`"
                            :state="$validator.errors.has(`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountB`) ? false : null"
                            :danger="$validator.errors.has(`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountB`)"
                            :danger-text="$validator.errors.first(`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountB`)"
                            data-vv-as="monto hora docente colaborador (otras actividades)"
                            v-validate="{required: isCollaboratorDocentHourAmountBRequired(idx), min_value: colaboratorDocentHourAmountBMinValue(idx)}"
                          />
                          <b-form-invalid-feedback
                            v-if="$validator.errors.has(`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountB`)"
                          >
                            {{$validator.errors.first(`workHoursAndRemuneration[${idx}].collaboratorDocentHourAmountB`)}}
                          </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group>
                          <label :for="`workHoursAndRemuneration[${idx}].factorB`">
                            Factor (otras actividades)
                            <span
                              v-html="required(`workHoursAndRemuneration[${idx}].factorB`)"
                            />
                          </label>
                          <b-form-input
                            type="number"
                            :data-cy="`workHoursAndRemuneration[${idx}].factorB`"
                            :name="`workHoursAndRemuneration[${idx}].factorB`"
                            :data-vv-as="'factor'"
                            placeholder='Factor...'
                            v-model="formData.workHoursAndRemuneration[idx].factorB"
                            :state="$validator.errors.has(`workHoursAndRemuneration[${idx}].factorB`) ? false : null"
                            :danger="$validator.errors.has(`workHoursAndRemuneration[${idx}].factorB`)"
                            :danger-text="$validator.errors.first(`workHoursAndRemuneration[${idx}].factorB`)"
                            v-validate="{required: isFactorBRequired(idx), min_value: factorBMinValue(idx)}"
                          />
                          <b-form-invalid-feedback
                            v-if="$validator.errors.has(`workHoursAndRemuneration[${idx}].factorB`)"
                          >
                            {{$validator.errors.first(`workHoursAndRemuneration[${idx}].factorB`)}}
                          </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group>
                          <label :for="`workHoursAndRemuneration[${idx}].subtotalB`">
                            Subtotal (otras actividades)
                          </label>
                          <b-form-input
                            disabled
                            :data-cy="`workHoursAndRemuneration[${idx}].subtotalB`"
                            :name="`workHoursAndRemuneration[${idx}].subtotalB`"
                            :data-vv-as="'subtotal'"
                            placeholder='Producto datos anteriores...'
                            v-model="data[idx].subtotalB"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12 d-flex justify-content-end">
                        <vs-button
                          color="danger"
                          type="border"
                          icon="delete"
                          @click="removeWorkHoursAndRemunerationRow(idx)"
                        >
                          Eliminar fila
                        </vs-button>
                      </b-col>
                    </b-row>
                  </vs-td>
                </vs-tr>
                </tbody>
                <tfoot>
                <vs-tr>
                  <vs-td colspan="3">
                    <vs-button
                      class="w-100"
                      color="primary"
                      type="border"
                      icon="add"
                      @click="addWorkHoursAndRemunerationRow"
                    >
                      Agregar fila
                    </vs-button>
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td colspan="3">
                    <b-form-group>
                      <label for="serviceHours">
                        Horas de servicios
                        <span class="text-xs text-muted">
                        (Suma de todas las horas docentes y otras actividades)
                      </span>
                      </label>
                      <b-form-input
                        disabled
                        type="number"
                        data-cy='serviceHours'
                        name='serviceHours'
                        data-vv-as='horas de servicios'
                        placeholder='Suma de horas docentes y otras actividades...'
                        v-model="formData.serviceHours"
                        :state="$validator.errors.has('serviceHours') ? false : null"
                        :danger="$validator.errors.has('serviceHours')"
                        :danger-text="$validator.errors.first('serviceHours')"
                      />
                    </b-form-group>
                  </vs-td>
                </vs-tr>
                </tfoot>
              </template>
            </vs-table>
          </div>
          <div class="col-12 mt-10" v-if="isDocenteForm">
            <vs-table
              class="wrap-table shadow"
              hoverFlat
              :data="(formData.schedules || [])"
              noDataText="No hay horarios aún"
            >
              <template>
                <thead>
                <th colspan="3" class="text-center">
                  Horarios
                </th>
                </thead>
                <tbody>
                <vs-tr v-for="(_, index) in formData.schedules" :key="index">
                  <vs-td class="table-part">
                    <b-form-group>
                      <label for="day">
                        Día de la semana
                        <span v-html="required('schedules[' + index + '].day')"/>
                      </label>
                      <v-select
                        :class="{'v-select-danger': $validator.errors.has('schedules[' + index + '].day')}"
                        :data-cy="'schedules[' + index + '].day'"
                        :name="'schedules[' + index + '].day'"
                        data-vv-as='fecha'
                        placeholder='Día de la semana...'
                        v-model="formData.schedules[index].day"
                        :state="$validator.errors.has('schedules[' + index + '].day')? false : null"
                        :danger="$validator.errors.has('schedules[' + index + '].day')"
                        :danger-text="$validator.errors.first('schedules[' + index + '].day')"
                        v-validate="'required'"
                        :options="weekDayOptions"
                      />
                      <v-invalid-feedback v-if="$validator.errors.has('schedules[' + index + '].day')">
                        {{ $validator.errors.first('schedules[' + index + '].day') }}
                      </v-invalid-feedback>
                    </b-form-group>
                  </vs-td>
                  <vs-td>
                    <b-form-group>
                      <label for="hour">
                        Hora
                        <span v-html="required('schedules[' + index + '].hour')"/>
                      </label>
                      <date-picker
                        :class="{'w-100': true,'danger': $validator.errors.has('schedules[' + index + '].hour')}"
                        type="time"
                        :data-cy="'schedules[' + index + '].hour'"
                        :name="'schedules[' + index + '].hour'"
                        data-vv-as='hora'
                        placeholder='Hora...'
                        format='HH:mm'
                        :show-second="false"
                        value-type='format'
                        v-model="formData.schedules[index].hour"
                        :danger="$validator.errors.has('schedules[' + index + '].hour')"
                        v-validate="'required|requiredTime'"
                        range
                        @input="validateSchedulesServiceHours"
                      >
                        <template slot="header">
                          <table class="w-100">
                            <tr>
                              <th class="w-50 text-center border-right-header">
                                Inicio
                              </th>
                              <th class="text-center">
                                Fin
                              </th>
                            </tr>
                          </table>
                        </template>
                      </date-picker>
                      <v-invalid-feedback v-if="$validator.errors.has('schedules[' + index + '].hour')">
                        {{ $validator.errors.first('schedules[' + index + '].hour') }}
                      </v-invalid-feedback>
                    </b-form-group>
                  </vs-td>
                  <vs-td class="align-middle">
                    <vs-button
                      class="-mb-3"
                      color="danger"
                      type="border"
                      icon="delete"
                      @click="removeSchedule(index)"
                    />
                  </vs-td>
                </vs-tr>
                </tbody>
                <tfoot>
                <vs-tr>
                  <vs-td colspan="3">
                    <vs-button
                      class="w-100"
                      color="primary"
                      type="border"
                      icon="add"
                      @click="addSchedule"
                    >
                      Agregar horario
                    </vs-button>
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td colspan="3">
                    <v-invalid-feedback data-cy="schedulesServiceHoursError" v-if="schedulesServiceHoursError">
                      {{ schedulesServiceHoursError }}
                    </v-invalid-feedback>
                  </vs-td>
                </vs-tr>
                </tfoot>
              </template>
            </vs-table>
          </div>
          <div class="col-12 my-2">
            <vs-divider/>
          </div>
          <div class="col-12 mb-2">
            <h5>OTROS</h5>
          </div>
          <div class="col-12">
            <b-form-group>
              <label for="contractValidityDate">
                Vigencia del Contrato
                <span v-html="required('contractValidityDate')"/>
              </label>
              <date-picker
                :class="{
                'w-100': true,
                'danger': $validator.errors.has('contractValidityDate'),
              }"
                data-cy='contractValidityDate'
                name='contractValidityDate'
                data-vv-as='vigencia del contrato'
                v-model="formData.contractValidityDate"
                class="w-100"
                format='DD/MM/YYYY'
                value-type='DD/MM/YYYY'
                placeholder='03/12/2024 ~ 19/12/2024'
                :danger="$validator.errors.has('contractValidityDate')"
                v-validate="'required|requiredDateRange'"
                range
              />
              <v-invalid-feedback v-if="$validator.errors.has('contractValidityDate')">
                {{ $validator.errors.first('contractValidityDate') }}
              </v-invalid-feedback>
              <small v-if="formData.contractValidityDate[0] && formData.contractValidityDate[1]">
                {{ formData.contractValidityDateText }}
              </small>
            </b-form-group>
          </div>
          <div class="col-12 mb-3">
            <span class="text-primary">
                Los siguientes roles deben ser definidos por la persona solicitante al completar
                el formulario de solicitud de contratación de honorarios. Posteriormente,
                quienes ocupen estos roles participarán en el flujo de aprobación de los
                informes de actividades 2.0
              </span>
          </div>
          <div class="col-12">
            <b-form-group>
              <label for="administrativeResponsible">
                Responsable administrativo
                <span v-html="required('administrativeResponsible')"/>
              </label>
              <list-user
                label=""
                class="mb-1"
                autocomplete
                name="administrativeResponsible"
                data-cy='administrativeResponsible'
                data-vv-as='responsable administrativo'
                v-model="formData.administrativeResponsible"
                :state="$validator.errors.has('administrativeResponsible') ? false : null"
                :danger="$validator.errors.has('administrativeResponsible')"
                :danger-text="$validator.errors.first('administrativeResponsible')"
                v-validate="'required'"
                @full-user="formData.administrativeResponsibleComplete = $event"
              />
              <v-invalid-feedback v-if="$validator.errors.has('administrativeResponsible')">
                {{ $validator.errors.first('administrativeResponsible') }}
              </v-invalid-feedback>
              <span class="text-danger">
                Firmante (Responsable administrativo/a)*: Persona que formaliza la solicitud
                mediante su firma, asumiendo la responsabilidad administrativa correspondiente.
                Esta designación quedará registrada en el convenio. Será la única persona
                autorizada para firmar los informes de actividades.
              </span>
            </b-form-group>
          </div>
          <div class="col-12">
            <b-form-group>
              <label for="administrativeResponsiblePosition">
                Cargo responsable administrativo
                <span v-html="required('administrativeResponsiblePosition')"/>
              </label>
              <b-form-input
                data-cy='administrativeResponsiblePosition'
                name='administrativeResponsiblePosition'
                data-vv-as='cargo responsable administrativo'
                placeholder='Cargo responsable administrativo...'
                v-model="formData.administrativeResponsiblePosition"
                :state="$validator.errors.has('administrativeResponsiblePosition') ? false : null"
                :danger="$validator.errors.has('administrativeResponsiblePosition')"
                :danger-text="$validator.errors.first('administrativeResponsiblePosition')"
                v-validate="'required'"
              />
              <b-form-invalid-feedback
                v-if="$validator.errors.has('administrativeResponsiblePosition')"
              >
                {{ $validator.errors.first('administrativeResponsiblePosition') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12">
            <b-form-group>
              <label for="administrativeSupport">
                Soporte administrativo
                <span v-html="required('administrativeSupport')"/>
              </label>
              <list-user
                label=""
                autocomplete
                class="mb-1"
                name="administrativeSupport"
                data-cy='administrativeSupport'
                data-vv-as='soporte administrativo'
                v-model="formData.administrativeSupport"
                :state="$validator.errors.has('administrativeSupport') ? false : null"
                :danger="$validator.errors.has('administrativeSupport')"
                :danger-text="$validator.errors.first('administrativeSupport')"
                v-validate="'required'"
                @full-user="formData.administrativeSupportComplete = $event"
              />
              <v-invalid-feedback v-if="$validator.errors.has('administrativeSupport')">
                {{ $validator.errors.first('administrativeSupport') }}
              </v-invalid-feedback>
              <span class="text-danger">
                Verifica que los documentos estén completos, correctos y que se cumplan los
                requisitos formales para la tramitación.
              </span>
            </b-form-group>
          </div>
          <div class="col-12">
            <b-form-group>
              <label for="otherResponsiblesCompleteNew">
                Visador de Actividades
                <span v-html="required('otherResponsiblesComplete')"/>
              </label>
              <list-user
                label=""
                :options="users"
                name="otherResponsiblesCompleteNew"
                data-cy="otherResponsiblesCompleteNew"
                data-vv-as="visador de actividades"
                placeholder="Visador de Actividades..."
                v-model="formData.otherResponsiblesCompleteNew"
                :state="$validator.errors.has('otherResponsiblesCompleteNew') ? false : null"
                :danger="$validator.errors.has('otherResponsiblesCompleteNew')"
                :danger-text="$validator.errors.first('otherResponsiblesCompleteNew')"
                @full-user="formData.otherResponsibleComplete = $event"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('otherResponsiblesCompleteNew')">
                {{ $validator.errors.first('otherResponsiblesCompleteNew') }}
              </b-form-invalid-feedback>
              <span class="text-danger">
                Persona encargada de revisar y validar los productos entregables y/o las funciones realizadas
                durante el periodo correspondiente al informe de actividades, conforme a lo establecido en el convenio.
              </span>
            </b-form-group>
          </div>
          <div class="col-12 mt-5">
            <b-form-group>
              <label for="specificLaborArray">
                Indicar detalladamente la(s) labor(es) específica(s) que
                desempeñará la persona contratada
                <span v-html="required('administrativeResponsible')"/>
                <br/>
                <span class="text-xs mt-1">
                (En la redacción del convenio se utilizará esta misma información)
              </span>
              </label>
              <div
                class="row"
                v-for="(task, index) in formData.specificLaborArray"
                :key="`task-${index}`"
              >
                <div class="col-md-9 mt-3">
                  <b-form-textarea
                    rows="2"
                    data-cy='specificLaborArray'
                    name='specificLaborArray'
                    data-vv-as='labor específica'
                    placeholder='Labor específica...'
                    v-model="task.task"
                    :state="$validator.errors.has('specificLaborArray') ? false : null"
                    :maxlength="560"
                    :danger="$validator.errors.has('specificLaborArray')"
                    :danger-text="$validator.errors.first('specificLaborArray')"
                    v-validate="'required|min:1|max:560'"
                  />
                  <small class="form-text text-muted text-right">
                    {{ task.task ? task.task.length : 0 }} / 560
                  </small>
                  <b-form-invalid-feedback
                    v-if="$validator.errors.has('specificLaborArray')"
                  >
                    {{ $validator.errors.first('specificLaborArray') }}
                  </b-form-invalid-feedback>
                </div>
                <div class="col-md-3 mt-6">
                  <div class="text-center">
                    <vs-button
                      color="danger"
                      type="border"
                      icon="delete"
                      @click="removeTask(index)"
                    >
                      Eliminar fila
                    </vs-button>
                  </div>
                </div>
              </div>
              <div class="text-right mt-5">
                <vs-button
                  class="w-100"
                  color="primary"
                  type="border"
                  icon="add"
                  @click="addNewTask()"
                >
                  Agregar fila
                </vs-button>
              </div>
            </b-form-group>
          </div>
          <div class="col-12">
            <b-form-group>
              <label for="groupBelongsUser">
                Unidad Organizativa en la que se desempeña
                <span v-html="required('groupBelongsUser')"/>
              </label>
              <v-select
                :class="{ 'v-select-danger': $validator.errors.has('groupBelongsUser') }"
                name="groupBelongsUser"
                data-cy='groupBelongsUser'
                data-vv-as='unidad organizativa'
                placeholder="Seleccione una unidad organizativa"
                v-model="formData.groupBelongsUser"
                :options="companyGroups"
                :loading="loadingGroups"
                label="nombre"
                :state="$validator.errors.has('groupBelongsUser') ? false : null"
                :danger="$validator.errors.has('groupBelongsUser')"
                :danger-text="$validator.errors.first('groupBelongsUser')"
                v-validate="'required'"
                @input="onGroupSelected"
              />
              <v-invalid-feedback v-if="$validator.errors.has('groupBelongsUser')">
                {{ $validator.errors.first('groupBelongsUser') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 my-2">
            <vs-divider/>
          </div>
          <div class="col-12 mb-2">
            <h5>DATOS DE TRANSFERENCIA</h5>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="bank">
                Banco
                <span v-html="required('bank')"/>
              </label>
              <v-select
                :class="{ 'v-select-danger': $validator.errors.has('bank') }"
                data-cy='bank'
                name='bank'
                data-vv-as='banco'
                :placeholder="bankLoadingText"
                v-model="formData.bank"
                :options="bankOptions"
                :loading="loadingBankOptions"
                :disabled="loadingBankOptions"
                label="text"
                :reduce="opt => opt.value"
                :state="$validator.errors.has('bank') ? false : null"
                :danger="$validator.errors.has('bank')"
                :danger-text="$validator.errors.first('bank')"
                v-validate="'required'"
              />
              <v-invalid-feedback v-if="$validator.errors.has('bank')">
                {{ $validator.errors.first('bank') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="bankAccountType">
                Tipo de cuenta
                <span v-html="required('bankAccountType')"/>
              </label>
              <v-select
                :class="{ 'v-select-danger': $validator.errors.has('bankAccountType') }"
                data-cy='bankAccountType'
                name='bankAccountType'
                data-vv-as='tipo de cuenta'
                placeholder="-- Selecciona un tipo de cuenta --"
                v-model="formData.bankAccountType"
                :options="bankAccountTypes"
                :state="$validator.errors.has('bankAccountType') ? false : null"
                :danger="$validator.errors.has('bankAccountType')"
                :danger-text="$validator.errors.first('bankAccountType')"
                v-validate="'required'"
              />
              <v-invalid-feedback v-if="$validator.errors.has('bankAccountType')">
                {{ $validator.errors.first('bankAccountType') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="bankAccountNumber">
                N° de cuenta
                <span v-html="required('bankAccountNumber')"/>
              </label>
              <b-form-input
                data-cy='bankAccountNumber'
                name='bankAccountNumber'
                data-vv-as='número de cuenta'
                placeholder='N° de cuenta...'
                v-model="formData.bankAccountNumber"
                :state="$validator.errors.has('bankAccountNumber') ? false : null"
                :danger="$validator.errors.has('bankAccountNumber')"
                :danger-text="$validator.errors.first('bankAccountNumber')"
                v-validate="'required'"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('bankAccountNumber')">
                {{ $validator.errors.first('bankAccountNumber') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12">
            <b-form-group>
              <label for="totalAmount">
                Monto total de la contratación{{ isNotDocenteForm ? ' (BRUTO)' : '' }}
                <span v-html="required('totalAmount')"/>
              </label>
              <input-currency
                class="mb-0"
                label=""
                :options="currencyInputOptions"
                :disabled="true"
                data-cy='totalAmount'
                name='totalAmount'
                data-vv-as='monto total de la contratación'
                :placeholder="isDocenteForm ? 'Resultado de los datos anteriores...' : 'Monto total de la contratación...'"
                v-model="formData.totalAmount"
                :state="$validator.errors.has('totalAmount') ? false : null"
                :danger="$validator.errors.has('totalAmount')"
                :danger-text="$validator.errors.first('totalAmount')"
                v-validate="'required'"
                @input="log"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('totalAmount')">
                {{ $validator.errors.first('totalAmount') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12">
            <b-form-group>
              <label for="paymentPeriod">
                Periodo de pago
                <span v-html="required('paymentPeriod')"/>
                <br/>
                <span class="text-xs mt-1">
                (En fecha establecida por la Universidad para el pago de honorarios)
              </span>
              </label>
              <v-select-payment-period
                :parent="$vnode"
                name="paymentPeriod"
                data-cy='paymentPeriod'
                data-vv-as='periodo de pago'
                v-model="formData.paymentPeriod"
                :state="$validator.errors.has('paymentPeriod') ? false : null"
                :danger="$validator.errors.has('paymentPeriod')"
                :danger-text="$validator.errors.first('paymentPeriod')"
                v-validate="'required'"
              />
              <v-invalid-feedback v-if="$validator.errors.has('paymentPeriod')">
                {{ $validator.errors.first('paymentPeriod') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12">
            <b-form-group>
              <label for="contractPaymentPeriod">
                Periodicidad del pago de la contratación
                <span v-html="required('contractPaymentPeriod')"/>
              </label>
              <v-select-contract-payment-period
                :parent="$vnode"
                name="contractPaymentPeriod"
                data-cy='contractPaymentPeriod'
                data-vv-as='periodicidad del pago de la contratación'
                v-model="formData.contractPaymentPeriod"
                :state="$validator.errors.has('contractPaymentPeriod') ? false : null"
                :danger="$validator.errors.has('contractPaymentPeriod')"
                :danger-text="$validator.errors.first('contractPaymentPeriod')"
                v-validate="'required'"
              />
              <v-invalid-feedback v-if="$validator.errors.has('contractPaymentPeriod')">
                {{ $validator.errors.first('contractPaymentPeriod') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6" v-if="!isDocenteForm">
            <b-form-group>
              <label for="serviceExpenseClassification">
                Clasificación del gasto (solo para proyecto)
                <span v-html="required('serviceExpenseClassification')"/>
              </label>
              <select-options
                name="serviceExpenseClassification"
                options-group="fisabs-service-expense-classification"
                v-model="formData.serviceExpenseClassification"
                data-cy="service-expense-classification"
                :alphabetical-sort=true
                data-vv-as='clasificación del gasto (solo para proyecto)'
                :state="$validator.errors.has('serviceExpenseClassification') ? false : null"
                :danger="$validator.errors.has('serviceExpenseClassification')"
                :danger-text="$validator.errors.first('serviceExpenseClassification')"
                v-validate="'required'"
                :filter-by-doc-type="DOCUMENT_TYPE.SCH"
              />
              <v-invalid-feedback v-if="$validator.errors.has('serviceExpenseClassification')">
                {{ $validator.errors.first('serviceExpenseClassification') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="serviceProjectObjective">
                Objetivo del proyecto
              </label>
              <b-form-input
                data-cy='serviceProjectObjective'
                name='serviceProjectObjective'
                data-vv-as='objetivo del proyecto'
                placeholder='Ingrese el objetivo del proyecto'
                v-model="formData.serviceProjectObjective"
                :state="$validator.errors.has('serviceProjectObjective') ? false : null"
                :danger="$validator.errors.has('serviceProjectObjective')"
                :danger-text="$validator.errors.first('serviceProjectObjective')"
              />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="serviceResult">
                Resultado / Hito / Actividad principal / Indicador
              </label>
              <b-form-input
                data-cy='serviceResult'
                name='serviceResult'
                data-vv-as='Resultado / Hito / Actividad principal / Indicador'
                placeholder='Ingrese el resultado/hito/actividad principal/indicador'
                v-model="formData.serviceResult"
                :state="$validator.errors.has('serviceResult') ? false : null"
                :danger="$validator.errors.has('serviceResult')"
                :danger-text="$validator.errors.first('serviceResult')"
              />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group>
              <label for="serviceExpenseCode">
                Código del gasto en el plan de gastos del proyecto
              </label>
              <b-form-input
                data-cy='serviceExpenseCode'
                name='serviceExpenseCode'
                data-vv-as='código del gasto en el plan de gastos del proyecto'
                placeholder='Ingrese el código del gasto en el plan de gastos del proyecto'
                v-model="formData.serviceExpenseCode"
                :state="$validator.errors.has('serviceExpenseCode') ? false : null"
                :danger="$validator.errors.has('serviceExpenseCode')"
                :danger-text="$validator.errors.first('serviceExpenseCode')"
              />
            </b-form-group>
          </div>
          <div class="col-12 mt-5">
            <vs-table
              hoverFlat
              class="wrap-table shadow"
              :data="formData.paymentPeriodBreakdown || []"
              noDataText="No hay actividades aún"
            >
              <template slot-scope="{data}">
                <thead>
                <th class="text-center">
                  Desglose del periodo de pago
                </th>
                </thead>
                <tbody>
                <vs-tr
                  :key="idx"
                  v-for="(_, idx) in data"
                >
                  <vs-td class="table-part" :data="data[idx]">
                    <b-row
                      :ref="`paymentPeriodBreakdown[${idx}].row`"
                      class="border mx-1 my-2 py-4"
                    >
                      <b-col cols="6">
                        <b-form-group>
                          <label :for="`paymentPeriodBreakdown[${idx}].description`">
                            Descripción
                            <span v-html="required(`paymentPeriodBreakdown[${idx}].description`)" />
                          </label>
                          <b-form-input
                            :name="`paymentPeriodBreakdown[${idx}].description`"
                            :data-cy='`paymentPeriodBreakdown[${idx}].description`'
                            data-vv-as='descripción'
                            placeholder='Descripción...'
                            v-model="data[idx].description"
                            :state="$validator.errors.has(`paymentPeriodBreakdown[${idx}].description`) ? false : null"
                            :danger="$validator.errors.has(`paymentPeriodBreakdown[${idx}].description`)"
                            :danger-text="$validator.errors.first(`paymentPeriodBreakdown[${idx}].description`)"
                            v-validate="'required'"
                          />
                          <b-form-invalid-feedback
                            v-if="$validator.errors.has(`paymentPeriodBreakdown[${idx}].description`)"
                          >
                            {{$validator.errors.first(`paymentPeriodBreakdown[${idx}].description`)}}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group>
                          <label :for="`paymentPeriodBreakdown[${idx}].amount`">
                            Monto bruto
                            <span v-html="required(`paymentPeriodBreakdown[${idx}].amount`)" />
                          </label>
                          <input-currency
                            class="mb-0"
                            label=""
                            :options="currencyInputOptions"
                            :name="`paymentPeriodBreakdown[${idx}].amount`"
                            :data-cy='`paymentPeriodBreakdown[${idx}].amount`'
                            data-vv-as='monto bruto'
                            placeholder='Monto bruto...'
                            v-model="data[idx].amount"
                            :state="$validator.errors.has(`paymentPeriodBreakdown[${idx}].amount`)? false : null"
                            :danger="$validator.errors.has(`paymentPeriodBreakdown[${idx}].amount`)"
                            :danger-text="$validator.errors.first(`paymentPeriodBreakdown[${idx}].amount`)"
                            v-validate="'required|min_value:1'"
                            @input="validateTotalAmount"
                          />
                          <b-form-invalid-feedback
                            v-if="$validator.errors.has(`paymentPeriodBreakdown[${idx}].amount`)"
                          >
                            {{$validator.errors.first(`paymentPeriodBreakdown[${idx}].amount`)}}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group>
                          <label :for="`paymentPeriodBreakdown[${idx}].project`">
                            Fuente de Financiamiento
                            <span
                              v-html="required(`paymentPeriodBreakdown[${idx}].project`)"
                            />
                          </label>
                          <select-options
                            :name="`paymentPeriodBreakdown[${idx}].project`"
                            options-group="fisabs-service-funding-source"
                            v-model="data[idx].project"
                            data-vv-as="fuente de financiamiento"
                            data-cy="`paymentPeriodBreakdown[${idx}].project`"
                            v-validate="'required'"
                          />
                          <b-form-invalid-feedback v-if="$validator.errors.has(`paymentPeriodBreakdown[${idx}].project`)">
                            {{$validator.errors.first(`paymentPeriodBreakdown[${idx}].project`) }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group>
                          <label :for="`paymentPeriodBreakdown[${idx}].responsibilityCenter`">
                            Centro de responsabilidad
                            <span
                              v-html="required(`paymentPeriodBreakdown[${idx}].responsibilityCenter`)"
                            />
                          </label>
                          <v-select-responsibility-center
                            :parent="$vnode"
                            :name="`paymentPeriodBreakdown[${idx}].responsibilityCenter`"
                            :data-cy='`paymentPeriodBreakdown[${idx}].responsibilityCenter`'
                            data-vv-as='centro de responsabilidad'
                            v-model="data[idx].responsibilityCenter"
                            :state="$validator.errors.has(`paymentPeriodBreakdown[${idx}].responsibilityCenter`)? false : null"
                            :danger="$validator.errors.has(`paymentPeriodBreakdown[${idx}].responsibilityCenter`)"
                            :danger-text="$validator.errors.first(`paymentPeriodBreakdown[${idx}].responsibilityCenter`)"
                            v-validate="'required'"
                          />
                          <v-invalid-feedback
                            v-if="$validator.errors.has(`paymentPeriodBreakdown[${idx}].responsibilityCenter`)"
                          >
                            {{$validator.errors.first(`paymentPeriodBreakdown[${idx}].responsibilityCenter`)}}
                          </v-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12 d-flex justify-content-end">
                        <vs-button
                          color="danger"
                          type="border"
                          icon="delete"
                          @click="removePaymentPeriodBreakdownRow(idx)"
                        >
                          Eliminar fila
                        </vs-button>
                      </b-col>
                      <b-col>
                        <v-invalid-feedback
                          data-cy="totalAmountError"
                          v-if="totalAmountError"
                        >
                          {{ totalAmountError }}
                        </v-invalid-feedback>
                      </b-col>
                    </b-row>
                  </vs-td>
                </vs-tr>
                </tbody>
                <tfoot>
                <vs-tr>
                  <vs-td colspan="3">
                    <vs-button
                      class="w-100"
                      color="primary"
                      type="border"
                      icon="add"
                      @click="addPaymentPeriodBreakdownRow"
                    >
                      Agregar fila
                    </vs-button>
                  </vs-td>
                </vs-tr>
                </tfoot>
              </template>
            </vs-table>
          </div>
          <div class="col-12 my-2">
            <vs-divider/>
          </div>
          <div class="col-12">
            <h4>Indicar si el convenio contempla</h4>
          </div>
          <div class="col-12 -mb-3 mt-3">
            <b-form-group>
              <div class="row">
                <label for="travelAllowance" class="col-8 align-content-center">
                  Derecho a Viáticos
                  <span v-html="required('travelAllowance')"/>
                </label>
                <b-form-radio-group
                  class="col-4"
                  data-cy='travelAllowance'
                  name='travelAllowance'
                  data-vv-as='derecho a viáticos'
                  v-model="formData.travelAllowance"
                  :state="$validator.errors.has('travelAllowance') ? false : null"
                  :danger="$validator.errors.has('travelAllowance')"
                  :danger-text="$validator.errors.first('travelAllowance')"
                  v-validate="'required'"
                >
                  <b-form-radio :value="true">Sí</b-form-radio>
                  <b-form-radio :value="false">No</b-form-radio>
                </b-form-radio-group>
                <b-form-invalid-feedback v-if="$validator.errors.has('travelAllowance')">
                  {{ $validator.errors.first('travelAllowance') }}
                </b-form-invalid-feedback>
              </div>
            </b-form-group>
          </div>
          <div class="col-12 mb-2" v-if="formData.travelAllowance">
            <b-form-group>
              <label for="travelAllowanceJustification">
                Justificación (derecho a viáticos)
                <span v-html="required('travelAllowanceJustification')"/>
              </label>
              <b-form-input
                data-cy='travelAllowanceJustification'
                name='travelAllowanceJustification'
                data-vv-as='justificación'
                placeholder='Justificación...'
                v-model="formData.travelAllowanceJustification"
                :state="$validator.errors.has('travelAllowanceJustification') ? false : null"
                :danger="$validator.errors.has('travelAllowanceJustification')"
                :danger-text="$validator.errors.first('travelAllowanceJustification')"
                v-validate="{required: isTravelAllowanceJustificationRequired,}"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('travelAllowanceJustification')">
                {{ $validator.errors.first('travelAllowanceJustification') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 -mb-3 mt-3">
            <b-form-group>
              <div class="row">
                <label for="landPassageRefund" class="col-8 align-content-center">
                  Reembolsos pasajes terrestres y/o combustible
                  <span v-html="required('landPassageRefund')"/>
                </label>
                <b-form-radio-group
                  class="col-4"
                  data-cy='landPassageRefund'
                  name='landPassageRefund'
                  data-vv-as='reembolsos pasajes terrestres y/o combustible'
                  v-model="formData.landPassageRefund"
                  :state="$validator.errors.has('landPassageRefund') ? false : null"
                  :danger="$validator.errors.has('landPassageRefund')"
                  :danger-text="$validator.errors.first('landPassageRefund')"
                  v-validate="'required'"
                >
                  <b-form-radio :value="true">Sí</b-form-radio>
                  <b-form-radio :value="false">No</b-form-radio>
                </b-form-radio-group>
                <b-form-invalid-feedback v-if="$validator.errors.has('landPassageRefund')">
                  {{ $validator.errors.first('landPassageRefund') }}
                </b-form-invalid-feedback>
              </div>
            </b-form-group>
          </div>
          <div class="col-12 mb-2" v-if="formData.landPassageRefund">
            <b-form-group>
              <label for="landPassageRefundJustification">
                Justificación (reembolsos pasajes terrestres y/o combustible)
                <span v-html="required('landPassageRefundJustification')"/>
              </label>
              <b-form-input
                data-cy='landPassageRefundJustification'
                name='landPassageRefundJustification'
                data-vv-as='justificación'
                placeholder='Justificación...'
                v-model="formData.landPassageRefundJustification"
                :state="$validator.errors.has('landPassageRefundJustification') ? false : null"
                :danger="$validator.errors.has('landPassageRefundJustification')"
                :danger-text="$validator.errors.first('landPassageRefundJustification')"
                v-validate="{ required: isLandPassageRefundJustificationRequired }"
              />
              <b-form-invalid-feedback
                v-if="$validator.errors.has('landPassageRefundJustification')"
              >
                {{ $validator.errors.first('landPassageRefundJustification') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 -mb-3 mt-3">
            <b-form-group>
              <div class="row">
                <label for="training" class="col-8 align-content-center">
                  Capacitaciones
                  <span v-html="required('training')"/>
                </label>
                <b-form-radio-group
                  class="col-4"
                  data-cy='training'
                  name='training'
                  data-vv-as='capacitaciones'
                  v-model="formData.training"
                  :state="$validator.errors.has('training') ? false : null"
                  :danger="$validator.errors.has('training')"
                  :danger-text="$validator.errors.first('training')"
                  v-validate="'required'"
                >
                  <b-form-radio :value="true">Sí</b-form-radio>
                  <b-form-radio :value="false">No</b-form-radio>
                </b-form-radio-group>
                <b-form-invalid-feedback v-if="$validator.errors.has('training')">
                  {{ $validator.errors.first('training') }}
                </b-form-invalid-feedback>
              </div>
            </b-form-group>
          </div>
          <div class="col-12 mb-2" v-if="formData.training">
            <b-form-group>
              <label for="trainingJustification">
                Justificación (capacitaciones)
                <span v-html="required('trainingJustification')"/>
              </label>
              <b-form-input
                data-cy='trainingJustification'
                name='trainingJustification'
                data-vv-as='justificación'
                placeholder='Justificación...'
                v-model="formData.trainingJustification"
                :state="$validator.errors.has('trainingJustification') ? false : null"
                :danger="$validator.errors.has('trainingJustification')"
                :danger-text="$validator.errors.first('trainingJustification')"
                v-validate="{required: isTrainingJustificationRequired}"
              />
              <b-form-invalid-feedback v-if="$validator.errors.has('trainingJustification')">
                {{ $validator.errors.first('trainingJustification') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-12 -mb-3 mt-3">
            <b-form-group>
              <div class="row">
                <label for="isPublicAgent" class="col-8 align-content-center">
                  Agente Público
                  <span v-html="required('isPublicAgent')"/>
                </label>
                <b-form-radio-group
                  class="col-4"
                  data-cy='isPublicAgent'
                  name='isPublicAgent'
                  data-vv-as='agente público'
                  v-model="formData.isPublicAgent"
                  :state="$validator.errors.has('isPublicAgent') ? false : null"
                  :danger="$validator.errors.has('isPublicAgent')"
                  :danger-text="$validator.errors.first('isPublicAgent')"
                  v-validate="'required'"
                >
                  <b-form-radio :value="true">Sí</b-form-radio>
                  <b-form-radio :value="false">No</b-form-radio>
                </b-form-radio-group>
                <b-form-invalid-feedback v-if="$validator.errors.has('isPublicAgent')">
                  {{ $validator.errors.first('isPublicAgent') }}
                </b-form-invalid-feedback>
              </div>
            </b-form-group>
          </div>
          <div class="col-12 my-2">
            <vs-divider/>
          </div>
          <div class="col-12">
            <h4>Documentos</h4>
          </div>
          <div class="col-12">
            <dynamic-file-selector
              v-if="!schAttachmentsSelectors.loading"
              :selectors="schAttachmentsSelectors.list
              .slice()
              .sort((a, b) => a.order - b.order)
              .map((sel) => ({ ...sel, ...sel.extra, index: sel.order }))
            "
              :object-to-evaluate="formData"
              :files="dynamicSelectorFiles"
              :reset-key="dfsResetKey"
              @update-files="updateFiles"
              @valid="(valid) => {
              dynamicFileSelectorValid = valid;
            }"
            />
            <div v-else>
              <b-skeleton animation="fade" width="100%"/>
              <b-skeleton animation="fade" width="100%"/>
            </div>
          </div>
        </div>
      </form>
      <vs-divider/>
      <div class="text-xs text-right">
        <b>Los campos marcados con <span class="text-danger">*</span> son obligatorios</b>
      </div>
      <form-action-buttons
        :saving="saving"
        :preview="preview"
        :back="back"
        :save="save"
        :saveDraft="saveDraft"
      />
      <repository-selector
        modal-id="add-repository-experience-file"
        :add-file="addExperienceFile"
        :files="experienceFiles"
        :remove-file="removeExperienceFile"
        :max-files="maxExperienceFiles"
      />
      <repository-selector
        modal-id="add-repository-expertise-file"
        :add-file="addExpertiseFile"
        :files="expertiseFiles"
        :remove-file="removeExpertiseFile"
        :max-files="maxExpertiseFiles"
      />
    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import { Validator } from 'vee-validate';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import es from 'vee-validate/dist/locale/es';
import {mapActions, mapGetters} from 'vuex';
import HandleDraft from "@/febos/global/documentManagement/mixins/HandleDraft";
import {ioCreateCustomDocument, ioGetCustomDocument} from '@/febos/servicios/api/customDocuments.api';
import HandlePreLoadData from "@/febos/global/documentManagement/mixins/HandlePreLoadData";
import { numToWords } from '@/febos/global/customDocuments/utils/numToWords';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import BFormInputRut from '@/components/inputs/BFormInputRut';
import PdfPreview from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/PdfPreview';
import FormActionButtons from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/FormActionButtons';
import DynamicFileSelector from '@/febos/global/customDocuments/components/dynamic-file-selector/DynamicFileSelector';
import { evaluateConditions } from '@/febos/global/customDocuments/components/dynamic-file-selector/utils';
import RepositorySelector from '@/febos/global/customDocuments/components/repository-selector/RepositorySelector';
import FileList from '@/febos/global/customDocuments/components/FileList';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import InputCurrency from '@/components/InputCurrency';
import VSelectAcademicDegree
from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectAcademicDegree';
import VSelectNationality
from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectNationality';
import VSelectCity from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectCity';
import VSelectTitle from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectTitle';
import VSelectUniversity from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectUniversity';
import VSelectSubject from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectSubject';
import VSelectCareer from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectCareer';
import VSelectResponsibilityCenter
from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectResponsibilityCenter';
import VSelectPaymentPeriod
from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectPaymentPeriod';
import VSelectContractPaymentPeriod
from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectContractPaymentPeriod';
import VSelectPeriod from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectPeriod';
import VSelectHeadOfCareer
from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectHeadOfCareer';
import VSelectAdministrativeSupport
from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectAdministrativeSupport';
import VSelectAdministrativeResponsible
from '@/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectAdministrativeResponsible';
import VSelectIsapres from '@/febos/global/customDocuments/components/VSelectIsapres';
import VSelectAfps from '@/febos/global/customDocuments/components/VSelectAfps';
import VInvalidFeedback from '@/febos/global/customDocuments/components/VInvalidFeedback';
import ValidateField from '@/febos/global/customDocuments/components/ValidateField';
import {
  FORM_TYPE_OPTIONS,
  FORM_TYPE,
  YES_OR_NO_OPTIONS,
  WEEK_DAY_OPTIONS,
  DOCUMENT_TYPE,
} from '@/febos/global/customDocuments/vistas/empresas/61980520-8/constants';
import SelectOptions from '@/febos/global/customDocuments/components/SelectOptions';
import ListUser from "@/febos/chile/lists/components/ListUser.vue";
import { getUsers } from "@/febos/servicios/api/usuarios.api";
import FormButtons from "@/febos/global/customDocuments/components/FormButtons.vue";
import Vue from "vue";
import { ioCompanyGroups } from '@/febos/servicios/api/empresas.api';
import { ioListOptions } from '@/febos/servicios/api/herramientas.api';

Validator.localize('es', es);
Validator.extend('requiredTime', {
  getMessage: (field) => `El campo ${field} es requerido`,
  validate(value) {
    if (Array.isArray(value)) {
      return value.length > 0 && value.every((v) => !!v);
    }
    return !!value;
  },
});
Validator.extend('requiredDateRange', {
  getMessage: (field) => `El campo ${field} es requerido`,
  validate(value) {
    return value && value.every((v) => !!v);
  },
});

const WORK_AND_REMUNERATION_EMPTY_DATA = {
  subject: '',
  subjectCode: '',
  subjectName: '',
  subjectCareer: '',
  headOfCareer: '',

  docentHours: null,
  collaboratorDocentHourAmountA: '',
  factorA: null,
  subtotalA: null,

  otherActivitiesHours: null,
  collaboratorDocentHourAmountB: '',
  factorB: null,
  subtotalB: null,
};

const PAYMENT_PERIOD_EMPTY_DATA = {
  description: '',
  amount: '',
  project: '',
  responsibilityCenter: '',
};

const ASSOCIATED_PRODUCT_EMPTY_DATA = {
  product: '',
  subproduct: '',
  period: '',
  bruteValuation: null,
};

const getDefaultFormData = () => ({
  formType: null,
  // DOCENTE:
  fullName: '',
  rut: '',
  birthDate: '',
  address: '',
  city: '',
  nationality: '',
  isStudent: '',
  email: '',
  phoneNumber: '',
  institutionalEmail: '',
  professionalTitle: '',
  university: '',
  academicDegree: '',

  healthInsurance: '',
  afp: '',

  serviceHours: null,
  schedules: [{
    day: '',
    hour: '',
  }],
  workHoursAndRemuneration: [{ ...WORK_AND_REMUNERATION_EMPTY_DATA }],
  serviceExpenseClassification: '',
  serviceProjectObjective: '',
  serviceResult: '',
  serviceExpenseCode: '',
  contractValidityDate: [
    null,
    null,
  ],
  contractValidityDateText: '',
  contractValidityDateStartText: '',
  contractValidityDateEndText: '',

  administrativeResponsible: '',
  administrativeResponsibleComplete: {},
  administrativeResponsiblePosition: '',
  administrativeSupport: '',
  otherResponsiblesCompleteNew: '',
  otherResponsibleComplete: {},
  administrativeSupportComplete: {},
  otherResponsibles: '',
  specificLaborArray: [{
    task: ''
  }],
  groupBelongsUser: null,
  bank: '',
  bankAccountType: '',
  bankAccountNumber: '',
  totalAmount: null,
  totalAmountText: '',
  paymentPeriod: '',
  contractPaymentPeriod: '',
  paymentPeriodBreakdown: [{
    ...PAYMENT_PERIOD_EMPTY_DATA,
  }],

  travelAllowance: false,
  travelAllowanceJustification: '',
  landPassageRefund: false,
  landPassageRefundJustification: '',
  training: false,
  trainingJustification: '',
  isPublicAgent: false,

  // NO DOCENTE:
  experience: '',
  expertise: '',
  weeklyHours: null,
  associatedProduct: [{ ...ASSOCIATED_PRODUCT_EMPTY_DATA }],
});
const DOC_TYPE = 'SCH';
export default {
  name: 'SCH',
  components: {
    FormButtons,
    ListUser,
    SelectOptions,
    VSelectAdministrativeSupport,
    VSelectAdministrativeResponsible,
    VSelectHeadOfCareer,
    FormActionButtons,
    PdfPreview,
    VSelectPeriod,
    VSelectContractPaymentPeriod,
    VSelectPaymentPeriod,
    VSelectResponsibilityCenter,
    InputCurrency,
    VSelectCity,
    RepositorySelector,
    DynamicFileSelector,
    FileList,
    UploadFile,
    VSelectAcademicDegree,
    VSelectNationality,
    VSelectTitle,
    VSelectUniversity,
    VSelectSubject,
    VSelectCareer,
    VInvalidFeedback,
    VSelectAfps,
    VSelectIsapres,
    BFormInputRut,
    DatePicker,
  },
  mixins: [StepTypes, HandleDraft, HandlePreLoadData],
  data() {
    const { documentId } = this.$route.query;
    return {
      DOCUMENT_TYPE,
      documentId,
      usersCompany: [],
      companyGroups: [],
      loadingGroups: false,
      bankOptions: [],
      loadingBankOptions: false,
      bankAccountTypes: ['Cuenta Vista', 'Cuenta Corriente', 'Cuenta de Ahorro'],
      formData: getDefaultFormData(),

      experienceFileError: '',
      experienceFile: {},
      experienceFiles: [],

      expertiseFileError: '',
      expertiseFile: {},
      expertiseFiles: [],

      formFiles: [],
      dynamicSelectorFiles: [],

      schedulesServiceHoursError: '',
      totalAmountError: '',

      saving: false,
      dynamicFileSelectorValid: false,
      error: {
        message: ''
      },
      inPreview: false,
      generatingPreview: false,
      pdfUrl: '',
      stepTypes: StepTypes,
      formTypeOptions: FORM_TYPE_OPTIONS,
      yesOrNoOptions: YES_OR_NO_OPTIONS,
      weekDayOptions: WEEK_DAY_OPTIONS,

      maxExperienceFiles: 1,
      maxExpertiseFiles: 1,

      currencyInputOptions: {
        locale: 'es-CL',
        currency: 'CLP',
        hideGroupingSeparatorOnFocus: false,
        currencyDisplay: 'hidden',
        precision: {
          min: 0,
          max: 2
        },
        useGrouping: true,
      },
    };
  },
  methods: {
    ...mapActions('List', [
      'fetchSchAttachmentsSelectors',
      'fetchUsers',
    ]),
    async loadBanks() {
      try {
        this.loadingBankOptions = true;
        const response = await ioListOptions({
          grupoOpcion: 'bancos-ed',
          filtros: 'deshabilitado:0',
        });
        const { opciones } = response.data;
        this.bankOptions = opciones.map((option) => ({
          value: option.valor,
          text: option.descripcion,
        })).sort((a, b) => a.text.localeCompare(b.text));
      } finally {
        this.loadingBankOptions = false;
      }
    },
    async loadCompanyGroups() {
      try {
        this.loadingGroups = true;
        const response = await ioCompanyGroups({
          empresaId: this.empresa.id,
        });

        let groups = [];
        if (response.data && response.data.grupos) {
          groups = response.data.grupos;
        } else if (Array.isArray(response.data)) {
          groups = response.data;
        }

        // Ordenar alfabéticamente por nombre
        this.companyGroups = groups.sort((a, b) => {
          const nameA = (a.nombre || '').toLowerCase();
          const nameB = (b.nombre || '').toLowerCase();
          return nameA.localeCompare(nameB, 'es');
        });
      } catch (error) {
        console.error('Error al cargar grupos de la empresa:', error);
        this.$vs.notify({
          title: 'Error',
          text: 'No se pudieron cargar las unidades de dependencia',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
        });
      } finally {
        this.loadingGroups = false;
      }
    },
    onGroupSelected(selectedGroup) {
      if (selectedGroup && selectedGroup.id && selectedGroup.nombre) {
        // Guardar solo ID y nombre
        this.$nextTick(() => {
          this.formData.groupBelongsUser = {
            id: selectedGroup.id,
            nombre: selectedGroup.nombre
          };
        });
      }
    },
    addNewTask() {
      this.formData.specificLaborArray.push({ task: '' });
    },
    removeTask(index) {
      if (this.formData.specificLaborArray.length === 1) {
        this.formData.specificLaborArray = [{
          task: ''
        }];
        return;
      }

      this.formData.specificLaborArray.splice(index, 1);
    },
    resetFormState() {
      this.formData = getDefaultFormData();
      this.experienceFileError = '';
      this.experienceFile = {};
      this.experienceFiles = [];
      this.expertiseFileError = '';
      this.expertiseFile = {};
      this.expertiseFiles = [];
      this.formFiles = [];
      this.dynamicSelectorFiles = [];
      this.schedulesServiceHoursError = '';
      this.totalAmountError = '';
      this.dynamicFileSelectorValid = false;
      this.inPreview = false;
      this.generatingPreview = false;
      this.pdfUrl = '';
    },
    updateFiles(files) {
      this.formFiles = [...files];
    },
    validateTotalAmount() {
      this.totalAmountError = '';
      const totalAmount = this.formData.totalAmount || 0;

      const totalAmountBreakdown = this.formData.paymentPeriodBreakdown
        .reduce((acc, period) => acc + Number(period.amount || 0), 0);

      if (totalAmount !== totalAmountBreakdown) {
        this.totalAmountError = 'La suma de los montos de los periodos de pago debe ser igual al monto total';
      }

      return totalAmount === totalAmountBreakdown;
    },
    validateSchedulesServiceHours() {
      this.schedulesServiceHoursError = '';
      const totalHours = this.formData.schedules.reduce((acc, schedule) => {
        const [startHour, endHour] = schedule.hour || [];
        if (!startHour || !endHour) return acc;

        const [startHourParts, endHourParts] = [startHour.split(':'), endHour.split(':')];
        const startHourMinutes = Number(startHourParts[0]) * 60 + Number(startHourParts[1]);
        const endHourMinutes = Number(endHourParts[0]) * 60 + Number(endHourParts[1]);

        return acc + (endHourMinutes - startHourMinutes) / 60;
      }, 0);

      if (totalHours > this.formData.serviceHours) {
        this.schedulesServiceHoursError = 'La suma de los horarios no puede ser mayor a las horas de servicio';
      }

      return totalHours <= this.formData.serviceHours;
    },
    async addExperienceFile(file) {
      this.experienceFileError = '';
      if (!Object.keys(file).length) {
        return;
      }

      if (file.failed) {
        this.experienceFileError.message = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.experienceFiles.push({ ...file, origen: 'experiencia' });
      this.experienceFileError.message = '';
    },
    removeAttachment(file) {
      this.formData.attachments = this.formData.attachments.filter((file) => file.id !== id);
    },
    removeExperienceFile(id) {
      this.experienceFiles = this.experienceFiles.filter((file) => file.id !== id);
    },
    log(value) {
      console.log('log: ', value);
    },
    async addExpertiseFile(file) {
      this.expertiseFileError = '';
      if (!Object.keys(file).length) {
        return;
      }

      if (file.failed) {
        this.expertiseFileError.message = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.expertiseFiles.push({ ...file, origen: 'expertise' });
      this.expertiseFileError.message = '';
    },
    removeExpertiseFile(id) {
      this.expertiseFiles = this.expertiseFiles.filter((file) => file.id !== id);
    },
    validateAttachments() {
      if (this.formData.experience && !this.experienceFiles.length) {
        this.experienceFileError = 'Debes adjuntar un documento que acredite la experiencia';
      } else {
        this.experienceFileError = '';
      }

      if (this.formData.expertise && !this.expertiseFiles.length) {
        this.expertiseFileError = 'Debes adjuntar un documento que acredite la experticia';
      } else {
        this.expertiseFileError = '';
      }

      return this.experienceFileError === '' && this.expertiseFileError === '';
    },
    changeFormType() {
      this.$nextTick(() => {
        this.$validator.reset();
        this.resetFormState();
      });
    },
    setSubject(e, index) {
      this.formData.workHoursAndRemuneration[index].subjectCode = e.code;
      this.formData.workHoursAndRemuneration[index].subjectName = e.value;
    },
    addSchedule() {
      this.formData.schedules.push({
        day: '',
        hour: '',
      });
    },
    removeSchedule(index) {
      if (this.formData.schedules.length === 1) {
        this.formData.schedules = [{
          day: '',
          hour: '',
        }];
        return;
      }

      this.formData.schedules.splice(index, 1);
    },
    addRow(dataKey, emptyData, scrollOffset) {
      this.formData[dataKey].push({ ...emptyData });

      this.$nextTick(() => {
        this.scrollToElement(
          this.$refs[`${dataKey}[${this.formData[dataKey].length - 1}].row`][0],
          scrollOffset
        );
      });
    },
    removeRow(dataKey, emptyData, index, scrollOffset) {
      if (this.formData[dataKey].length === 1) {
        this.formData[dataKey] = [{ ...emptyData }];
        return;
      }

      this.formData[dataKey].splice(index, 1);
      this.$nextTick(() => {
        if (index !== this.formData[dataKey].length) return;
        this.scrollToElement(
          this.$refs[`${dataKey}[${index - 1}].row`][0],
          scrollOffset
        );
      });
    },
    addWorkHoursAndRemunerationRow() {
      this.addRow('workHoursAndRemuneration', WORK_AND_REMUNERATION_EMPTY_DATA, -100);
    },
    removeWorkHoursAndRemunerationRow(index) {
      this.removeRow('workHoursAndRemuneration', WORK_AND_REMUNERATION_EMPTY_DATA, index, -100);
    },
    addPaymentPeriodBreakdownRow() {
      this.addRow('paymentPeriodBreakdown', PAYMENT_PERIOD_EMPTY_DATA, -200);
    },
    removePaymentPeriodBreakdownRow(index) {
      this.removeRow('paymentPeriodBreakdown', PAYMENT_PERIOD_EMPTY_DATA, index, -200);
    },
    addAssociatedProductRow() {
      this.addRow('associatedProduct', ASSOCIATED_PRODUCT_EMPTY_DATA, -200);
    },
    removeAssociatedProductRow(index) {
      this.removeRow('associatedProduct', ASSOCIATED_PRODUCT_EMPTY_DATA, index, -200);
    },
    scrollToDataCyElement(dataCy) {
      const element = document.querySelector(`[data-cy="${dataCy}"]`);
      if (element) {
        this.scrollToElement(element, -200);
      }
    },
    scrollToElement(element, offsetY = 0) {
      if (element) {
        const elementRect = element.getBoundingClientRect();
        const offsetTop = window.pageYOffset + elementRect.top + offsetY;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        });
      }
    },
    disabledRange(date) {
      return date > new Date(new Date().getFullYear(), 11, 31);
    },
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    required(fieldName) {
      const item = this.$validator.fields.items.find((_item) => _item.name === fieldName);
      if (!item || !item.rules || !Object.keys(item.rules).length || !Object.keys(item.rules).includes('required')) {
        return '';
      }
      return "<span class='text-danger'><b>*</b></span>";
    },
    async validateForm() {
      this.$validator.errors.clear();
      const validForm = await this.$validator.validateAll();
      const validTotalAmount = this.validateTotalAmount();
      const validAttachments = !this.isNotDocenteForm
        || this.validateAttachments();
      const validSchedulesServiceHours = !this.isNotDocenteForm
        || this.validateSchedulesServiceHours();
      const validDynamicFileSelector = this.dynamicFileSelectorValid;

      const result = !!validForm
        && validAttachments
        && validTotalAmount
        && validSchedulesServiceHours
        && validDynamicFileSelector;

      if (!result) {
        this.$vs.notify({
          title: 'Ups!',
          text: 'Revisa los campos marcados en rojo',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
      }

      if (!validForm) {
        const firstError = this.$validator.errors.items[0];
        this.scrollToDataCyElement(firstError.field);
      } else if (!validAttachments) {
        this.scrollToDataCyElement('experience');
      } else if (!validTotalAmount) {
        this.scrollToDataCyElement('totalAmountError');
      } else if (!validSchedulesServiceHours) {
        this.scrollToDataCyElement('schedulesServiceHoursError');
      }

      return result;
    },
    getMergedAttachments() {
      // Orígenes manejados manualmente fuera del DynamicFileSelector
      const manualOrigins = ['experiencia', 'expertise', 'adjunto'];
      // Archivos del DynamicFileSelector, excluyendo los que se manejan manualmente
      const dfsFiles = (this.formFiles || [])
        .filter((file) => !manualOrigins.includes(file.origen));
      // Combinar: experiencia + expertise (estado actual del usuario) + DFS + adjuntos manuales
      const manualFiles = (this.formData.attachments || [])
        .filter((file) => file.origen === 'adjunto');
      const allFiles = [
        ...this.experienceFiles,
        ...this.expertiseFiles,
        ...dfsFiles,
        ...manualFiles,
      ];
      // Deduplicar por id
      const seen = new Set();
      return allFiles.filter((file) => {
        if (seen.has(file.id)) return false;
        seen.add(file.id);
        return true;
      });
    },
    async save() {
      const isValid = await this.validateForm();
      if (!isValid) {
        return;
      }

      this.error.message = '';
      this.saving = true;
      const from = this.$route.query?.from;
      try {
        this.$bvToast.toast(
          'Guardando documento',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );

        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            ...(from === 'draft' && { replace: 'si' })
          },
          formData: {
            ...this.getFormData(),
            status: 1,
            attachments: this.getMergedAttachments(),
          }
        };

        const response = await ioCreateCustomDocument(payload);
        await this.notifyCreation(response.data.name || '');
        await this.generatePdf(response.data.document.id);
      } finally {
        this.saving = false;
      }
    },
    async saveDraft() {

      this.error.message = '';
      this.saving = true;
      const { from } = this.$route.query;
      try {
        this.$bvToast.toast(
          'Guardando documento',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );

        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            numerar: 'no',
            ...(from === 'draft' && { replace: 'si' })
          },
          formData: {
            ...this.getFormData(),
            attachments: this.getMergedAttachments(),
            status: '3'
          }
        };

        const response = await ioCreateCustomDocument(payload);
        const docId = response.data?.document?.id || response.data?.documentId;
        if (docId) {
          await this.updateRouteAsDraft(docId);
        }
        this.$bvToast.toast(
          'Borrador guardado correctamente',
          {
            title: '¡Listo!',
            variant: 'success',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 3000
          }
        );
      } finally {
        this.saving = false;
      }
    },
    backToForm() {
      this.inPreview = false;
    },
    getFormData() {
      return {
        ...this.formData,

        serviceHours: this.formData.serviceHours || 0,
        totalAmount: this.formData.totalAmount || 0,

        weeklyHours: this.formData.weeklyHours || 0,

        isDocenteForm: this.isDocenteForm,
        isNotDocenteForm: this.isNotDocenteForm,

        workHoursAndRemuneration: this.formData.workHoursAndRemuneration.map((item) => ({
          ...item,
          docentHours: item.docentHours || 0,
          collaboratorDocentHourAmountA: item.collaboratorDocentHourAmountA || 0,
          factorA: item.factorA || 0,
          subtotalA: item.subtotalA || 0,

          otherActivitiesHours: item.otherActivitiesHours || 0,
          collaboratorDocentHourAmountB: item.collaboratorDocentHourAmountB || 0,
          factorB: item.factorB || 0,
          subtotalB: item.subtotalB || 0,
        })),

        paymentPeriodBreakdown: this.formData.paymentPeriodBreakdown.map((item) => ({
          ...item,
          amount: item.amount || 0,
        })),
      };
    },
    async preview() {
      const isValid = await this.validateForm();
      if (!isValid) {
        return;
      }

      this.pdfUrl = '';
      this.inPreview = true;
      this.generatingPreview = true;

      try {
        this.$bvToast.toast(
          'Generando previsualización',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 3000
          }
        );
        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            simular: 'si',
          },
          formData: {
            ...this.getFormData(),
            borrador: true,
          }
        };

        const { data: { pdf } } = await ioCreateCustomDocument(payload);

        if (!pdf || pdf === '') {
          this.$bvToast.toast(
            'Ups!',
            {
              title: 'No se pudo generar la previsualización',
              variant: 'warning',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 5000
            }
          );
          this.backToForm();
        }

        this.pdfUrl = `${pdf}#toolbar=0&navpanes=0&scrollbar=0`;
      } finally {
        this.generatingPreview = false;
      }
    },
    async generatePdf(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await ioGetCustomDocument('SCH', id, { pdf: 'si' });
      this.$bvToast.toast(
        'Archivo generado',
        {
          title: 'Listo!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      window.open(response.data.pdf, '_blank');
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    updateSubtotals(index) {
      const item = this.formData.workHoursAndRemuneration[index];

      if (item.docentHours && item.collaboratorDocentHourAmountA && item.factorA) {
        this.formData.workHoursAndRemuneration[index].subtotalA = Math.round(
          item.docentHours
          * item.collaboratorDocentHourAmountA
          * item.factorA
          * 10
        ) / 10;
      } else {
        this.formData.workHoursAndRemuneration[index].subtotalA = null;
      }

      if (item.otherActivitiesHours && item.collaboratorDocentHourAmountB && item.factorB) {
        this.formData.workHoursAndRemuneration[index].subtotalB = Math.round(
          item.otherActivitiesHours
          * item.collaboratorDocentHourAmountB
          * item.factorB
          * 10
        ) / 10;
      } else {
        this.formData.workHoursAndRemuneration[index].subtotalB = null;
      }
    },
    updateServiceHours() {
      let totalServiceHours = 0.0;
      this.formData.workHoursAndRemuneration.forEach((item) => {
        if (item.docentHours) {
          totalServiceHours += parseFloat(item.docentHours);
        }
        if (item.otherActivitiesHours) {
          totalServiceHours += parseFloat(item.otherActivitiesHours);
        }
      });

      if (this.formData.serviceHours !== totalServiceHours && totalServiceHours >= 0) {
        this.formData.serviceHours = totalServiceHours;
      }
    },
    updateTotal() {
      let totalAmount = 0.0;
      if (this.isDocenteForm) {
        this.formData.workHoursAndRemuneration.forEach((item) => {
          if (item.subtotalA) {
            totalAmount += parseFloat(item.subtotalA);
          }
          if (item.subtotalB) {
            totalAmount += parseFloat(item.subtotalB);
          }
        });
      } else {
        this.formData.associatedProduct.forEach((item) => {
          if (item.bruteValuation) {
            totalAmount += parseFloat(item.bruteValuation);
          }
        });
      }
      if (this.formData.totalAmount !== totalAmount && totalAmount >= 0) {
        this.formData.totalAmount = totalAmount;
        this.formData.totalAmountText = numToWords(totalAmount);
      }
      this.validateTotalAmount();
    },
    parseDate(dateStr) {
      if (!dateStr) return null;
      const [day, month, year] = dateStr.split('/').map(Number);
      return new Date(year, month - 1, day);
    },
    updateContractValidityDateText() {
      if (this.formData.contractValidityDate[0] && this.formData.contractValidityDate[1]) {
        const [start, end] = this.formData.contractValidityDate;
        const formatOptions = { day: 'numeric', month: 'long', year: 'numeric' };
        const formatter = new Intl.DateTimeFormat('es-ES', formatOptions);

        const parsedStart = this.parseDate(start);
        const parsedEnd = this.parseDate(end);

        if (parsedStart) this.formData.contractValidityDateStart = parsedStart;
        if (parsedEnd) this.formData.contractValidityDateEnd = parsedEnd;

        const startDate = formatter.format(parsedStart);
        const endDate = formatter.format(parsedEnd);

        this.formData.contractValidityDateText = `Desde el ${startDate} hasta el ${endDate}`;
        this.formData.contractValidityDateStartText = startDate;
        this.formData.contractValidityDateEndText = endDate;
      } else {
        this.formData.contractValidityDateText = '';
        this.formData.contractValidityDateStartText = '';
        this.formData.contractValidityDateEndText = '';
      }
    },
    docentHoursMinValue(index) {
      return this.isDocentHoursRequired(index) ? 1 : 0;
    },
    isDocentHoursRequired(index) {
      const item = this.formData.workHoursAndRemuneration[index];
      return (
        item.otherActivitiesHours === null
        || item.otherActivitiesHours < 1
        || (item.collaboratorDocentHourAmountA !== null && item.collaboratorDocentHourAmountA > 1)
      );
    },
    colaboratorDocentHourAmountAMinValue(index) {
      return this.isCollaboratorDocentHourAmountARequired(index) ? 1 : 0;
    },
    isCollaboratorDocentHourAmountARequired(index) {
      const item = this.formData.workHoursAndRemuneration[index];
      return (
        (item.docentHours !== null && item.docentHours > 0)
        || (item.factorA !== null && item.factorA > 0)
      );
    },
    factorAMinValue(index) {
      return this.isFactorARequired(index) ? 1 : 0;
    },
    isFactorARequired(index) {
      const item = this.formData.workHoursAndRemuneration[index];
      return item.collaboratorDocentHourAmountA !== null && item.collaboratorDocentHourAmountA > 0;
    },
    otherActivitiesHoursMinValue(index) {
      return this.isOtherActivitiesHoursRequired(index) ? 1 : 0;
    },
    isOtherActivitiesHoursRequired(index) {
      const item = this.formData.workHoursAndRemuneration[index];
      return (
        item.docentHours === null
        || item.docentHours < 1
        || (item.collaboratorDocentHourAmountB !== null && item.collaboratorDocentHourAmountB > 1)
      );
    },
    colaboratorDocentHourAmountBMinValue(index) {
      return this.isCollaboratorDocentHourAmountBRequired(index) ? 1 : 0;
    },
    isCollaboratorDocentHourAmountBRequired(index) {
      const item = this.formData.workHoursAndRemuneration[index];
      return (
        (item.otherActivitiesHours !== null && item.otherActivitiesHours > 0)
        || (item.factorB !== null && item.factorB > 0)
      );
    },
    factorBMinValue(index) {
      return this.isFactorBRequired(index) ? 1 : 0;
    },
    isFactorBRequired(index) {
      const item = this.formData.workHoursAndRemuneration[index];
      return item.collaboratorDocentHourAmountB !== null && item.collaboratorDocentHourAmountB > 0;
    },
  },
  watch: {
    'formData.workHoursAndRemuneration': {
      handler(newVal) {
        newVal.forEach((item, index) => {
          this.updateSubtotals(index);
        });
        this.updateServiceHours();
        this.updateTotal();
      },
      deep: true
    },
    'formData.associatedProduct': {
      handler() {
        this.updateTotal();
      },
      deep: true
    },
    // CONTRACT VALIDITY
    'formData.contractValidityDate': 'updateContractValidityDateText'
  },
  computed: {
    ...mapGetters('List', [
      'schAttachmentsSelectors',
    ]),
    ...mapGetters('Empresas', [
      'empresa',
    ]),
    users() {
      return this.usersCompany
        .map((user) => ({ label: user.nombre, id: user.id, value: user.id }));
    },
    isNotDocenteForm() {
      return this.formData.formType === FORM_TYPE.NO_DOCENTE;
    },
    isDocenteForm() {
      return this.formData.formType === FORM_TYPE.DOCENTE;
    },
    // VALIDATIONS
    isTravelAllowanceJustificationRequired() {
      return this.formData.travelAllowance;
    },
    isLandPassageRefundJustificationRequired() {
      return this.formData.landPassageRefund;
    },
    isTrainingJustificationRequired() {
      return this.formData.training;
    },
    bankLoadingText() {
      return this.loadingBankOptions
        ? 'Cargando bancos'
        : '-- Selecciona un banco --';
    },
  },
  async mounted() {
    const { data: { usuarios } } = await getUsers({
      empresaId: this.empresa.id,
      page: 1,
      limit: 9999,
      query: ''
    });

    this.usersCompany = usuarios;
    await this.loadCompanyGroups();
  },
  async created() {
    this.updateContractValidityDateText();
    this.fetchSchAttachmentsSelectors();
    this.loadBanks();
  }
};
</script>
<style>
.mx-datepicker-header {
  padding: 0;
}

.border-right-header {
  border-right: 1px solid #e8e8e8 !important;
}

.mx-input-wrapper .mx-input {
  padding: 18px 1rem !important;
}

.vs__dropdown-toggle {
  padding: 0px 0 5px 0;
}

.table-part {
  width: 43%;
}

.vs-table--tr {
  vertical-align: top !important;
}

.mx-datepicker.danger .mx-input-wrapper .mx-input {
  border-color: #ea5455;
}

.text-xs {
  color: #757575 !important;
}
</style>
